import { render, staticRenderFns } from "./searchContactList.vue?vue&type=template&id=60bc6715&scoped=true&"
import script from "./searchContactList.vue?vue&type=script&lang=js&"
export * from "./searchContactList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("../../../assets/css/leftnavChat.css?vue&type=style&index=0&id=60bc6715&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "60bc6715",
  "1a746051"
  
)

export default component.exports